import { useCallback } from "react";

import type { PermissionConfig } from "@lib/permissionConstants";
import sharedConstants from "@lib/shared_constants";

import type { RealPermission } from "@services/permissions/types";

/**
 * Used to infer the scope at which the permission should be checked. Prefers the least expansive scope for which
 * the permission is valid. For Teams checks both the "enabled_for_territories" flag and presence in the
 * sharedConstants to be safe.
 */
export const useInferPermissionScope = (
  permissionToPermissionConfig: (permission: RealPermission) => PermissionConfig
) => {
  return useCallback(
    (permission: RealPermission) => {
      const permissionConfig = permissionToPermissionConfig(permission);

      const territoryPermissions = sharedConstants.PERMISSIONS.PERMISSIONS_BY_SCOPE["team"];
      const appGroupPermissions = sharedConstants.PERMISSIONS.PERMISSIONS_BY_SCOPE["appGroup"];

      if (permissionConfig.enabled_for_territories && territoryPermissions.some((perm) => perm === permission)) {
        return "team";
      } else if (appGroupPermissions.some((perm) => perm === permission)) {
        return "appGroup";
      }
      return "company";
    },
    [permissionToPermissionConfig]
  );
};
